import { rt } from "../i18n/runtime";

export const normalizeNotificationLang = (lang) => (lang === "en" ? "en" : "tr");

const TR_TO_EN_VALUE_MAP = [

  ["Aile Yönetimi bildirim sistemi sorunsuz çalışıyor.", "Family Planner notification system is working correctly."],
  ["Aile Yönetimi bildirim sistemi sorunsuz çalışıyor", "Family Planner notification system is working correctly"],
  ["Bu Haftaki Event", "This Week's Event"],
  ["Bu Haftaki", "This Week's"],
  ["Görev is due today", "Task is due today"],
  ["Görev is due tomorrow", "Task is due tomorrow"],
  ["Belge İçin", "Document"],
  ["geçerlilik tarihi yaklaşıyor", "validity date is approaching"],
  ["son tarihi geçti", "due date has passed"],
  ["son tarihi yarın", "is due tomorrow"],
  ["bugün tamamlanmalı", "must be completed today"],
  ["taskinin", "task's"],
  ["taskini", "task"],
  ["taski", "task"],
  ["ürününü almayı unutma", "don't forget to buy"],
  ["almayı unutma", "don't forget to take"],
  ["alma zamanı geldi", "it's time to take"],
  ["Sağlık Randevusu", "Health Appointment"],
  ["Sağlık randevusu", "health appointment"],
  ["Takvim Hatırlatması", "Calendar Reminder"],
  ["Alışveriş Hatırlatması", "Shopping Reminder"],
  ["Görev Hatırlatması", "Task Reminder"],
  ["İlaç Hatırlatması", "Medicine Reminder"],
  ["İlaç Hatırlatıcı", "Medicine Reminder"],
  ["İlaç Vakti Yaklaşıyor", "Medicine Time Approaching"],
  ["Test Bildirimi", "Test Notification"],
  ["Coğrafi Sınır", "Geofence"],
  ["coğrafi sınır", "geofence"],
  ["Güvenli Alan", "Safe Zone"],
  ["güvenli alan", "safe zone"],
  ["Geciken Görev", "Overdue Task"],
  ["Geciken görev", "Overdue task"],
  ["görev bugün son gün", "task is due today"],
  ["Görev bugün son gün", "Task is due today"],
  ["görev yarın son gün", "task is due tomorrow"],
  ["Görev yarın son gün", "Task is due tomorrow"],
  ["bugün son gün", "due today"],
  ["yarın son gün", "due tomorrow"],
  ["Bugünkü", "Today's"],
  ["bugünkü", "today's"],
  ["Yarınki", "Tomorrow's"],
  ["yarınki", "tomorrow's"],
  ["Bu haftaki", "This week's"],
  ["bu haftaki", "this week's"],
  ["etkinlikleri", "events"],
  ["Etkinlikleri", "Events"],
  ["etkinlikler", "events"],
  ["Etkinlikler", "Events"],
  ["etkinlik", "event"],
  ["Etkinlik", "Event"],
  ["randevusu", "appointment"],
  ["Randevusu", "Appointment"],
  ["randevu", "appointment"],
  ["Randevu", "Appointment"],
  ["İlaç", "Medicine"],
  ["ilaç", "medicine"],
  ["Görev", "Task"],
  ["görev", "task"],
  ["Belge", "Document"],
  ["belge", "document"],
  ["Alışveriş", "Shopping"],
  ["alışveriş", "shopping"],
  ["Dahiliye", "Internal Medicine"],

  ["Kadın doğum", "Gynecology"],
  ["kadın doğum", "gynecology"],
  ["dahiliye", "internal medicine"],
  ["dermatoloji", "dermatology"],
  ["Aile Hekimi", "Family Doctor"],
  ["Kardiyoloji", "Cardiology"],
  ["Ortopedi", "Orthopedics"],
  ["Göz", "Eye"],
  ["Diş", "Dental"],
  ["Kulak Burun Boğaz", "ENT"],
  ["Çocuk Sağlığı", "Pediatrics"],
  ["Kadın Doğum", "Gynecology"],
  ["Nöroloji", "Neurology"],
  ["Psikiyatri", "Psychiatry"],
  ["Dermatoloji", "Dermatology"],
  ["Fizik Tedavi", "Physical Therapy"],
  ["Üroloji", "Urology"],
  ["Genel Cerrahi", "General Surgery"],
  ["Radyoloji", "Radiology"],
  ["Laboratuvar", "Laboratory"],
  ["sonra", "later"],
  ["önce", "before"],
  ["saat", "at"],
  ["dakika", "minutes"],
  ["gün kaldı", "days left"],
  ["gün gecikti", "days overdue"],
  ["giriş yaptı", "entered"],
  ["çıkış yaptı", "left"],
  ["oluşturuldu", "created"],
  ["tanımlandı", "created"],
  ["kontrol edin", "check it"],
  ["kontrol et", "check"],
  ["bekleyen ürün", "pending item"],
  ["bekleyen ürünler", "pending items"],
];

const EN_TO_TR_VALUE_MAP = [
  ["Health Appointment", "Sağlık Randevusu"],
  ["health appointment", "sağlık randevusu"],
  ["Calendar Reminder", "Takvim Hatırlatması"],
  ["Shopping Reminder", "Alışveriş Hatırlatması"],
  ["Task Reminder", "Görev Hatırlatması"],
  ["Medicine Reminder", "İlaç Hatırlatması"],
  ["Medicine Time Approaching", "İlaç Vakti Yaklaşıyor"],
  ["Test Notification", "Test Bildirimi"],
  ["Geofence", "Coğrafi Sınır"],
  ["geofence", "coğrafi sınır"],
  ["Safe Zone", "Güvenli Alan"],
  ["safe zone", "güvenli alan"],
  ["Overdue Task", "Geciken Görev"],
  ["Overdue task", "Geciken görev"],
  ["Today's", "Bugünkü"],
  ["today's", "bugünkü"],
  ["Tomorrow's", "Yarınki"],
  ["tomorrow's", "yarınki"],
  ["This week's", "Bu haftaki"],
  ["Internal Medicine", "Dahiliye"],
  ["Family Doctor", "Aile Hekimi"],
  ["Cardiology", "Kardiyoloji"],
  ["Appointment", "Randevu"],
  ["appointment", "randevu"],
  ["Medicine", "İlaç"],
  ["medicine", "ilaç"],
  ["Task", "Görev"],
  ["task", "görev"],
  ["Document", "Belge"],
  ["document", "belge"],
];

const applyPairs = (text, pairs) => {
  let out = String(text || "");
  pairs.forEach(([from, to]) => {
    out = out.split(from).join(to);
  });
  return out;
};

const smartLegacyTrToEn = (text) => {
  let s = String(text || "").trim();
  if (!s) return s;

  // Remove repeated icons before pattern matching, then restore nothing: titles already have icons in UI.
  s = s.replace(/^(🔴|🟠|🟡|📅|📁|🛒|💊|✅|🧪|📢|⏰|❤️|🏥)\s+/u, (m) => m.trim() + " ").trim();

  let m = s.match(/^(.+?)\s+için\s+(?:sağlık\s+)?randevu$/i);
  if (m) return `Appointment for ${translateKnownNotificationValue(m[1].trim(), "en")}`;

  m = s.match(/^(.+?)\s+için\s+(\d+)\s+gün\s+kaldı$/i);
  if (m) return `${m[2]} days left for ${translateKnownNotificationValue(m[1].trim(), "en")}`;

  m = s.match(/^(.+?)\s+(\d+)\s+gün\s+kaldı$/i);
  if (m) return `${m[2]} days left for ${translateKnownNotificationValue(m[1].trim(), "en")}`;

  m = s.match(/^(?:\d+\s+days\s+left\s+for\s+)?(?:📁\s*)?Belge\s+İçin$/i);
  if (m) return s.match(/^(\d+)/)?.[1] ? `${s.match(/^(\d+)/)[1]} days left for Document` : "Document reminder";

  m = s.match(/^(.+?)\s+Belge\s+İçin$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} Document`;

  m = s.match(/^(.+?)\s+(\d+)\s+gün\s+gecikti$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} is ${m[2]} days overdue`;

  m = s.match(/^(.+?)\s+bugün\s+son\s+gün$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} is due today`;

  m = s.match(/^(.+?)\s+yarın\s+son\s+gün$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} is due tomorrow`;

  m = s.match(/^"(.+?)"\s+taskinin\s+son\s+tarihi\s+geçti\.?$/i);
  if (m) return `The due date for "${m[1].trim()}" has passed.`;

  m = s.match(/^"(.+?)"\s+taski\s+bugün\s+tamamlanmalı\.?$/i);
  if (m) return `"${m[1].trim()}" must be completed today.`;

  m = s.match(/^"(.+?)"\s+taskinin\s+son\s+tarihi\s+yarın\.?$/i);
  if (m) return `"${m[1].trim()}" is due tomorrow.`;

  m = s.match(/^"(.+?)"\s+taskini\s+unutma!?$/i);
  if (m) return `Don't forget the task "${m[1].trim()}"!`;

  m = s.match(/^"(.+?)"\s+görevini\s+unutma!?$/i);
  if (m) return `Don't forget the task "${m[1].trim()}"!`;

  m = s.match(/^(.+?)\s+—\s+1\s+saat\s+sonra\s*\((.+?)\)$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} — in 1 hour (${m[2].trim()})`;

  m = s.match(/^(.+?)\s+—\s+5\s+dakika\s+sonra\s*\((.+?)\)$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} — in 5 minutes (${m[2].trim()})`;

  m = s.match(/^"(.+?)"\s+ilacını\s+alma\s+zamanı\s+geldi\.\s*Saat:\s*(.+)$/i);
  if (m) return `It's time to take "${m[1].trim()}". Time: ${m[2].trim()}`;

  m = s.match(/^"(.+?)"\s+it's\s+time\s+to\s+take\s+your\s+medicine\.\s*Time:\s*(.+)$/i);
  if (m) return `It's time to take "${m[1].trim()}". Time: ${m[2].trim()}`;

  m = s.match(/^(.+?)\s+ilacını\s+almayı\s+unutma!?$/i);
  if (m) return `Don't forget to take ${translateKnownNotificationValue(m[1].trim(), "en")}!`;

  m = s.match(/^"(.+?)"\s+ürününü\s+almayı\s+unutma!?$/i);
  if (m) return `Don't forget to buy "${m[1].trim()}"!`;

  m = s.match(/^(.+?)\s+etkinliğini\s+unutma!?$/i);
  if (m) return `Don't forget the event ${translateKnownNotificationValue(m[1].trim(), "en")}!`;

  m = s.match(/^(.+?)\s*\(Time:\s*(.+?)\)\s+etkinliğini\s+unutma!?$/i);
  if (m) return `Don't forget the event ${translateKnownNotificationValue(m[1].trim(), "en")} (Time: ${m[2].trim()})!`;

  m = s.match(/^(.+?)\s*\(Saat:\s*(.+?)\)\s+etkinliğini\s+unutma!?$/i);
  if (m) return `Don't forget the event ${translateKnownNotificationValue(m[1].trim(), "en")} (Time: ${m[2].trim()})!`;

  m = s.match(/^(.+?)\s+·\s+Saat:\s*(.+)$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} · Time: ${m[2].trim()}`;

  m = s.match(/^(.+?)\s+·\s+Time:\s*(.+)$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} · Time: ${m[2].trim()}`;

  m = s.match(/^(.+?)\s+için\s+geçerlilik\s+tarihi\s+yaklaşıyor\.?$/i);
  if (m) return `The validity date for "${m[1].replace(/^"|"$/g, "").trim()}" is approaching.`;

  m = s.match(/^Shopping\s+listesinde\s+bekleyen\s+(\d+)\s+ürün\s+var\.?$/i);
  if (m) return `There are ${m[1]} pending items in the shopping list.`;

  m = s.match(/^There\s+are\s+pending\s+items\s+in\s+the\s+shopping\s+list:\s+(\d+)\s+items\s+pending\.?$/i);
  if (m) return `There are ${m[1]} pending items in the shopping list.`;

  m = s.match(/^(.+?)\s+listeye\s+"(.+?)"\s+ekledi$/i);
  if (m) return rt("notify.shoppingAdded", { name: m[1], item: m[2] }, "en");

  m = s.match(/^(.+?),\s+"(.+?)"\s+ürününü\s+alındı\s+olarak\s+işaretledi$/i);
  if (m) return rt("notify.shoppingBought", { name: m[1], item: m[2] }, "en");

  m = s.match(/^"(.+?)"\s+görevi\s+sana\s+atandı$/i);
  if (m) return rt("notify.taskAssigned", { task: m[1] }, "en");

  m = s.match(/^(.+?),\s+"(.+?)"\s+görevini\s+tamamladı$/i);
  if (m) return rt("notify.taskCompleted", { name: m[1], task: m[2] }, "en");

  m = s.match(/^(.+?)\s+"(.+?)"\s+alanına\s+(girdi|çıktı|cikti)\s+·\s+(.+)$/i);
  if (m) return `${m[1].trim()} ${m[3].toLocaleLowerCase("tr-TR").startsWith("g") ? "entered" : "left"} the "${m[2].trim()}" area · ${m[4].trim()}`;

  m = s.match(/^(.+?)\s+alanına\s+(girdi|çıktı|cikti)\s+·\s+(.+)$/i);
  if (m) return `${translateKnownNotificationValue(m[1].trim(), "en")} ${m[2].toLocaleLowerCase("tr-TR").startsWith("g") ? "entered" : "left"} · ${m[3].trim()}`;

  return applyPairs(s, TR_TO_EN_VALUE_MAP)
    .replace(/\btaski\b/g, "task")
    .replace(/\btaskini\b/g, "task")
    .replace(/\btaskinin\b/g, "task's")
    .replace(/\betkinliğini\b/g, "event")
    .replace(/\bürününü\b/g, "item")
    .replace(/\bilacını\b/g, "medicine")
    .replace(/\bSaat:/g, "Time:")
    .replace(/\s+/g, " ")
    .trim();
};

const smartLegacyEnToTr = (text) => applyPairs(text, EN_TO_TR_VALUE_MAP);

export const translateKnownNotificationValue = (value, lang = "tr") => {
  const normalized = normalizeNotificationLang(lang);
  if (value === null || value === undefined) return value;
  const text = String(value);
  return normalized === "en" ? smartLegacyTrToEn(text) : smartLegacyEnToTr(text);
};

const interpolateNotificationTemplate = (value, vars = {}) => {
  if (value === null || value === undefined) return value;

  return String(value).replace(
    /\{\{\s*([A-Za-z0-9_]+)\s*\}\}|\(\(\s*([A-Za-z0-9_]+)\s*\)\)/g,
    (placeholder, mustacheKey, legacyKey) => {
      const key = mustacheKey || legacyKey;
      if (!Object.prototype.hasOwnProperty.call(vars, key)) return placeholder;
      const replacement = vars[key];
      return replacement === null || replacement === undefined ? "" : String(replacement);
    }
  );
};

export const localizeNotificationContent = (notification = {}, lang = "tr") => {
  const normalized = normalizeNotificationLang(lang);
  const getField = (field) => {
    const key = notification?.[`${field}Key`];
    const vars = notification?.[`${field}Vars`] || {};
    if (key) return rt(key, vars, normalized);

    // data içinde title_tr/title_en veya body_tr/body_en varsa direkt kullan
    // cycleNotificationJob ve assistantNotificationService bu formatta saklar
    const data = notification?.data || {};
    const dataLangField = field === "baslik"
      ? (normalized === "en" ? (data.title_en || data.title_tr) : (data.title_tr || data.title_en))
      : (normalized === "en" ? (data.body_en || data.body_tr) : (data.body_tr || data.body_en));
    if (dataLangField) return interpolateNotificationTemplate(dataLangField, vars);

    const dict =
      notification?.[`${field}I18n`] ||
      notification?.[`${field}_i18n`] ||
      notification?.translations?.[field] ||
      null;

    if (dict && typeof dict === "object") {
      const localizedValue = dict[normalized] || dict.tr || dict.en || notification?.[field] || "";
      return interpolateNotificationTemplate(localizedValue, vars);
    }

    return interpolateNotificationTemplate(notification?.[field] || "", vars);
  };

  const familyName = String(notification?.familyName || notification?.aileAdi || "").trim();
  const prefixFamily = (text) => {
    const cleanText = translateKnownNotificationValue(text, normalized);
    if (!familyName) return cleanText;
    if (String(cleanText || "").startsWith(`${familyName} • `)) return cleanText;
    return `${familyName} • ${cleanText}`;
  };

  return {
    baslik: prefixFamily(getField("baslik")),
    aciklama: translateKnownNotificationValue(getField("aciklama"), normalized),
    familyName,
    language: normalized,
  };
};
